export default "__VITE_ASSET__BfneB16V__"